import { parseNucleusError } from '@/utils/helpers';

// Nucleus requires the webhook target to be an https:// URL (see JobWebhookConfig serializer).
export const isValidHttpsUrl = (value) => {
  if (!value) return false;
  try {
    const parsed = new URL(value.trim());
    return parsed.protocol === 'https:';
  } catch {
    return false;
  }
};

export const modalitiesToOptions = (modalities = []) => modalities.map((m) => ({ value: m.id, label: m.short_name }));

// Map a config's modality_ids back to select options, using the loaded modality list for labels.
export const idsToModalityOptions = (ids = [], modalities = []) =>
  ids.map((id) => {
    const match = modalities.find((m) => m.id === id);
    return { value: id, label: match?.short_name ?? id };
  });

// Resolve a config's modality_ids to modality objects ({ id, short_name }) for display,
// falling back to the raw id as the label when a modality can't be found.
export const idsToModalities = (ids = [], modalities = []) => ids.map((id) => modalities.find((m) => m.id === id) ?? { id, short_name: id });

export const jobFeedErrorMessage = (error, fallback = 'An error occurred') => {
  return parseNucleusError(error, 'Job feed config') || error?.data?.detail || fallback;
};
